import { HttpClient, HttpErrorResponse, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NotificationService } from '../index';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService {

  constructor(private http: HttpClient, 
              private router: Router,
              private notification: NotificationService,
              private spinner: NgxSpinnerService) { }

    
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
    .pipe(catchError((error: HttpErrorResponse) => {
      let errorMessage = '';
      if (error.error instanceof ErrorEvent) {
        errorMessage = error.error.message;
      } else {
        if (error.status === 401) {
          localStorage.clear();
          this.router.navigate(['/']);
          this.spinner.hide();
        }
        // Provide more detailed error messages
        if (error.status === 0) {
          errorMessage = 'Connection error - backend API is not responding. Make sure the API at ' + request.url + ' is running.';
        } else {
          errorMessage = error.error?.message || `HTTP Error ${error.status}: ${error.statusText}`;
        }
      }
      return throwError(() => new Error(errorMessage));
    }),

    map((res: any) => {
      const status = res?.body?.statusCode || '';
      if (status == '000' || status == '') {
        return res;
      }
      this.notification.error(res.body.message);
      this.spinner.hide();
    }), 

    map(res => {
      return res;
    })
    );
  }
}
